import React from 'react';
import { CountdownPage } from '../components/CountdownPage';
export function HomePage() {
  return <CountdownPage data-id="element-788" />;
}